import { render, staticRenderFns } from "./CreateFamilyKeyLog.vue?vue&type=template&id=15bdb30c&lang=pug&"
import script from "./CreateFamilyKeyLog.vue?vue&type=script&lang=ts&"
export * from "./CreateFamilyKeyLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports